import { useEffect, useRef, useState } from 'react';
import './styles/cursor.css';

/**
 * Component representing a custom cursor for the application.
 * @returns {JSX.Element} The Cursor component.
 */
export default function Cursor({fadeOut}) {
    const [isMobileDevice, changeDevice] = useState(true)
    const secondaryCursor = useRef(null);
    const mainCursor = useRef(null);
    const positionRef = useRef({
        mouseX: 0,
        mouseY: 0,
        destinationX: 0,
        destinationY: 0,
        distanceX: 0,
        distanceY: 0,
        key: -1,
    });
    const hoveringPosition = useRef({
        element: null,
        x: 0,
        y: 0,
        key: -1,
    });

    useEffect(() => {
        document.addEventListener("mousemove", (event) => {
            const { clientX, clientY } = event;

            const mouseX = clientX;
            const mouseY = clientY;

            if(secondaryCursor.current) {
                positionRef.current.mouseX = mouseX - secondaryCursor.current.clientWidth / 2;
                positionRef.current.mouseY = mouseY - secondaryCursor.current.clientHeight / 2;
                mainCursor.current.style.transform = `translate3d(${mouseX - mainCursor.current.clientWidth / 2}px, ${mouseY - mainCursor.current.clientHeight / 2}px, 0)`;
            }
        });

        const observe = () => {
            hoveringPosition.current.key = requestAnimationFrame(observe);
            if(secondaryCursor.current) {
                if (hoveringPosition.current.element) {
                    let child = hoveringPosition.current.element.getElementsByClassName('cursor-hoverable')[0];
                    const rect = child.getBoundingClientRect();

                    let x = rect.left;
                    let y = rect.top;
                    hoveringPosition.current.x = x;
                    hoveringPosition.current.y = y;

                        secondaryCursor.current.style.borderRadius = getComputedStyle(child).borderRadius;
                        secondaryCursor.current.style.height = getComputedStyle(child).height;
                        secondaryCursor.current.style.width = getComputedStyle(child).width;

                } else {
                    hoveringPosition.current.x = 0;
                    hoveringPosition.current.y = 0;

                    secondaryCursor.current.style.borderRadius = "var(--base-height)";
                    secondaryCursor.current.style.height = "var(--base-height)";
                    secondaryCursor.current.style.width = "var(--base-height)";
                }
            }
        };

        document.addEventListener("mouseover", (e) => {
            let parent = e.target.closest(".cursor-detect-hover");
            if (parent) {
                hoveringPosition.current.element = parent;
            } else {
                hoveringPosition.current.element = null;
            }
        });

        observe();
    }, []);

    useEffect(() => {
        const followMouse = () => {
            positionRef.current.key = requestAnimationFrame(followMouse);
            if(secondaryCursor.current) {
                const { mouseX, mouseY, destinationX, destinationY, distanceX, distanceY } = positionRef.current;
                if (!destinationX || !destinationY || hoveringPosition.current.x || hoveringPosition.current.y) {
                    positionRef.current.destinationX = hoveringPosition.current.x || hoveringPosition.current.y ? hoveringPosition.current.x : mouseX;
                    positionRef.current.destinationY = hoveringPosition.current.x || hoveringPosition.current.y ? hoveringPosition.current.y : mouseY;
                } else {
                    positionRef.current.distanceX = (hoveringPosition.current.x || hoveringPosition.current.y ? hoveringPosition.current.x : mouseX - destinationX) * 0.03;
                    positionRef.current.distanceY = (hoveringPosition.current.x || hoveringPosition.current.y ? hoveringPosition.current.y : mouseY - destinationY) * 0.03;
                    if (Math.abs(positionRef.current.distanceX) + Math.abs(positionRef.current.distanceY) < 0.1) {
                        positionRef.current.destinationX = hoveringPosition.current.x || hoveringPosition.current.y ? hoveringPosition.current.x : mouseX;
                        positionRef.current.destinationY = hoveringPosition.current.x || hoveringPosition.current.y ? hoveringPosition.current.y : mouseY;
                    } else {
                        positionRef.current.destinationX += distanceX;
                        positionRef.current.destinationY += distanceY;
                    }
                }
                secondaryCursor.current.style.transform = `translate3d(${destinationX}px, ${destinationY}px, 0)`;
            }
            if(window.matchMedia("(pointer: coarse)").matches) {
                changeDevice(true)
            } else {
                changeDevice(false)
            }
        };
        followMouse();
    }, []);


    if(!isMobileDevice) {
        return (
            <div className={`cursor${fadeOut ? " fade-out" : ""}`}>
                <span className="small" ref={mainCursor}></span>
                <span className="big" ref={secondaryCursor}></span>
            </div>
        );
    }
}